import { Component, Ref} from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AddressesContainer extends ThemeComponent {
    @Ref openFormButtons!: [HTMLButtonElement];
    @Ref closeFormButtons!: [HTMLButtonElement];

    private openForm(openButton: HTMLButtonElement) {
        const targetValue = openButton.dataset.target;
        const targetType = openButton.dataset.type;
        const targetEl = document.querySelector(`${targetValue}`);

        if (targetEl) {
            targetEl.classList.remove('visually-hidden');
            targetEl.classList.add('active');

            if (!targetType) {
                document.body.classList.add('drawer-open');
            }
        }

    }

    private closeForm(closeButton: HTMLButtonElement) {
        const targetValue = closeButton.dataset.target;
        const targetType = closeButton.dataset.type;
        const targetEl = document.querySelector(`${targetValue}`);

        if (targetEl) {
            targetEl.classList.add('visually-hidden');
            targetEl.classList.remove('active');

            if (!targetType) {
                document.body.classList.remove('drawer-open');
            }
        }
    }

    init() {
        for (const openFormButton of this.openFormButtons) {
            this.$listen(openFormButton, 'click', () => this.openForm(openFormButton));
        }

        for (const closeFormButton of this.closeFormButtons) {
            this.$listen(closeFormButton, 'click', () => this.closeForm(closeFormButton));
        }
    }


}

